<template>
  <div id="home" style="flex-grow: 1;" v-loading.fullscreen.lock="changeLoading">
    <Loading :loading="submitLoading" />
    <div style="background-color: white; margin: 10px 20px">
      <div style="padding-left: 2rem">
        <!--search area-->
        <el-form
          :inline="true"
          class="demo-form-inline"
          style="margin-left: 6rem; padding-top: 2rem"
        >
          <el-row :gutter="20">
            <el-col :span="8">
              <!-- 目的城市子组件 returnParentValue：给子组件赋值   returnParentValue：子组件返回值（调用方法接收）-->
              <destination
                :returnParentValue="searchForm.cityName"
                :parentCityCode="searchForm.cityCode"
                @returnCityInfo="setDestination"
                :isHotCity="false"
              ></destination>
            </el-col>
            <el-col :span="12">
              <!-- 入住、离店时间子组件 setValue：给子组件赋值   returnCheckDate：子组件返回值（调用方法接收）-->
              <date-picker @returnCheckDate="setCheckDate"></date-picker>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top: 20px">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <el-form-item label="酒店Id:">
                  <el-input
                    v-model="hotelIds"
                    style="width: 300px;"
                    autocomplete="off"
                    placeholder="多个酒店Id请用,隔开最多填写30个酒店Id"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <span style="color: red">* </span>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <el-form-item label="酒店名称:">
                <el-input
                  v-model="searchForm.hotelName"
                  placeholder="请输入酒店名称"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <el-form-item style="float: right">
                  <el-button
                    type="warning"
                    class="harpIDbtn"
                    @click="hotelAsync()"
                    >同步</el-button
                  >
                  <el-button
                    type="warning"
                    class="harpIDbtn"
                    @click="searchHotel()"
                    >搜索</el-button
                  >
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <hr
          style="
            margin: 1rem -14rem 0rem;
            background-color: rgb(241 243 245);
            height: 0.2rem;
            border: none;
          "
        />
        <el-table
          :data="tableData"
          v-show="tableData.length > 0"
          style="width: 90%; margin-top: 50px; margin-left: 100px"
        >
          <el-table-column
            prop="sourceId"
            label="酒店代码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cityCode"
            label="城市编码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cityName"
            label="FX城市名称"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="data.name.zh-CN"
            label="酒店名称-中文"
            align="center"
            width="250"
          ></el-table-column>
          <el-table-column
            prop="data.name.en"
            label="酒店名称-英文"
            align="center"
            width="250"
          ></el-table-column>
          <el-table-column
            prop="startRating"
            label="星级"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="contactNumber"
            label="联系电话"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="data.address.zh-CN"
            label="地址"
            align="center"
          ></el-table-column>
           <el-table-column
            prop="data.bookingDeptEmail"
            label="酒店预订部邮箱"
            align="center"
            width="150"
          ></el-table-column>
        </el-table>
        <el-table
          :data="tableStaticData"
          v-show="tableStaticData.length > 0 && tableData.length == 0"
          border
          style="width: 90%; margin-top: 30px; margin-left: 100px"
        >
          <el-table-column
            prop="id"
            label="FX酒店ID"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name.zh-CN"
            label="酒店名称-中文"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name.en"
            label="酒店名称-英文"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="contactNumber"
            label="联系电话"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="countryName"
            label="国家"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="provinceName"
            label="省份"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cityName"
            label="城市"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="address.zh-CN"
            label="中文地址"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="address.en"
            label="英文地址"
            align="center"
          ></el-table-column>
           <el-table-column
            prop="bookingDeptEmail"
            label="酒店预订部邮箱"
            align="center"
          ></el-table-column>
          <el-table-column prop="isActive" label="是否在售" align="center">
            <template #default="{ row }">
              <i v-if="row.isActive" class="el-icon-check"></i>
              <i v-if="!row.isActive" class="el-icon-close"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="tableHotelAreaData"
          v-show="tableHotelAreaData.length > 0 && tableData.length == 0"
          border
          style="width: 90%; margin-top: 30px; margin-left: 100px"
        >
          <el-table-column
            prop="hotelDescriptiveInfo.id"
            label="FX酒店ID"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="hotelDescriptiveInfo.name.zh-CN"
            label="酒店名称-中文"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="hotelDescriptiveInfo.name.en"
            label="酒店名称-英文"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="hotelDescriptiveInfo.contactNumber"
            label="联系电话"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="hotelDescriptiveInfo.address.zh-CN"
            label="中文地址"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="hotelDescriptiveInfo.address.en"
            label="英文地址"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="hotelDescriptiveInfo.bookingDeptEmail"
            label="酒店预订部邮箱"
            align="center"
          ></el-table-column>
        </el-table>
        <div style="text-align: right;padding-right: 5%;font-size: 1.3rem;margin-top: 10px;">
          共有{{ searchForm.Total }}条数据
        </div>
      </div>
    </div>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
  </div>
</template>
  
  <script>
import { getHotelList, getHotelLookup, hotelArea } from "@/api/shoppingData";
import Loading from "@/components/Loading.vue";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import DatePicker from "@/components/DatePicker.vue";
import { formatDateTime } from "@/utils/utils.js";
import Destination from "@/components/Destination.vue";
export default {
  name: "HBESyncHotel",
  components: {
    DatePicker,
    ConfirmBoxs,
    Loading,
    Destination,
  },
  data() {
    return {
      changeLoading: false,
      hotelIds: "",
      tableData: [],
      confirmMsg: "",
      confirmFlag: false,
      submitLoading: false,
      searchForm: {
        hotelName: "",
        Total: 0,
        checkInDate: "",
        checkOutDate: "",
        cityInfo: {}, //目的城市信息
        cityCode: "",
        cityName: "",
      },
      tableStaticData: [],
      tableHotelAreaData: [],
    };
  },
  methods: {
    //同步button
    async hotelAsync() {
      this.searchForm.Total = 0;
      this.tableData = [];
      this.tableStaticData = [];
      this.tableHotelAreaData = [];
      this.changeLoading = true;
      let searchparams = {
        params: {
          hotelIds: this.hotelIds,
        },
      };
      await getHotelList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = res.data.error.message;
            this.deleteFlag = false;
            this.tableData = res.data.items;
            this.searchForm.Total = res.data.pagination.total;
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = res.message;
            this.deleteFlag = false;
          }
        })
        .catch(function (error) {
          console.log("酒店信息 请求失败", error.objError);
        });
    },
    //获取静态酒店列表信息
    async getStaticHotelList() {
      let hotelParam = {
        params: {
          page: 1,
          per_page: 10,
          hotelName: this.searchForm.hotelName,
          hotelIds: this.hotelIds,
        },
      };
      let that = this;
      await getHotelLookup(hotelParam)
        .then((res) => {
          if (res.data.items.length == 0) {
            this.confirmFlag = true;
            this.confirmMsg = "未找到酒店信息";
          } else {
            that.tableStaticData = res.data.items;
            that.searchForm.Total = res.data.pagination.totalItemCount;
          }
        })
        .catch(function (error) {
          console.log("酒店信息 请求失败", error.objError);
        });
    },
    //获取动态酒店列表信息
    async getHotelAreaList() {
      let Hotelparams = {
        posCode: "YGO00001",
        //countryCode: "100000", //国家ID
        //cwtCityCode: "110100", //"310100"
        countryCode: this.searchForm.cityInfo.cityInfo.countryCode, //国家ID
        cwtCityCode: this.searchForm.cityInfo.cityCode, //"310100"
        checkInDate: formatDateTime(this.searchForm.checkInDate, "YYYY-MM-DD"),
        checkOutDate: formatDateTime(
          this.searchForm.checkOutDate,
          "YYYY-MM-DD"
        ),
        keyword: this.searchForm.hotelName,
        Language: ["en-US", "zh-CN"],
      };
      if (this.centerPointHotelId) {
        Hotelparams.centerPointHotelId = this.centerPointHotelId;
        (Hotelparams.radius = this.value), (Hotelparams.radiusUnit = "km");
      }
      let that = this;
      await hotelArea(Hotelparams)
        .then((res) => {
          if (res.data.error.code != 0) {
            this.confirmFlag = true;
            this.confirmMsg = "未找到酒店信息";
          } else {
            that.tableHotelAreaData = res.data.hotelList;
            that.searchForm.Total = res.data.pagination.totalItemCount;
          }
        })
        .catch(function (error) {
          console.log("酒店信息 请求失败", error.objError);
        });
    },
    //搜索button
    async searchHotel() {
      let searchStaticFlag = true;
      if (
        this.searchForm.checkInDate != "" &&
        this.searchForm.checkOutDate != "" &&
        this.searchForm.cityCode != ""
      ) {
        searchStaticFlag = false;
      }
      if (
        searchStaticFlag &&
        this.searchForm.hotelName == "" &&
        this.hotelIds == ""
      ) {
        this.confirmFlag = true;
        this.confirmMsg = "请选择目的城市、入离日期或输入酒店id、酒店名称";
        return;
      }
      this.tableData = [];
      this.tableStaticData = [];
      this.tableHotelAreaData = [];
      this.searchForm.Total = 0;
      this.submitLoading = true;
      if (searchStaticFlag) {
        await this.getStaticHotelList();
      } else {
        await this.getHotelAreaList();
      }
      this.submitLoading = false;
    },

    setConfirmFlag(value) {
      this.changeLoading = false;
      this.confirmFlag = value;
    },
    // 子组件赋值入住 离店时间 datepicker组件
    setCheckDate(value) {
      if (value != null) {
        // 入住
        this.searchForm.checkInDate = formatDateTime(value[0],"YYYY-MM-DD");
        // 离店
        this.searchForm.checkOutDate = formatDateTime(value[1],"YYYY-MM-DD");
      }
    },
    // 子组件赋值目的城市 destination组件
    setDestination(value) {
      this.searchForm.cityInfo = value;
      if (value.cityInfo) {
        this.searchForm.cityCode = value.cityInfo.cityCode;
      }
    },
  },
};
</script>
  
  <style scoped>
.loading {
  z-index: 999999;
}
.paginationsty {
  float: right;
  margin: 1rem 0;
}
.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
:deep(.el-range-editor.el-input__wrapper) {
  height: 4.2rem!important;
}
:deep(.el-input__wrapper) {
  height: 4rem!important;
}
</style>
  